<div
  #printContent
  id="printContent"
>
  <wf-main-content
    toolName="Group Summary"
    categoryName="Reports"
    [categoryIcon]="categoryIcon"
  >
    <div class="tool-scope flex flex-wrap justify-content-end">
      @if (showSchoolTeacherFilter()) {
        <div class="school-teacher-filter">
          <wf-school-teacher-filter
            class="print-hide"
            [districts]="districts()"
            [schools]="schools()"
            [teachers]="teachers()"
            [padding]="false"
            (filterChangeEvent)="schoolTeacherFilter.set($event)"
          >
          </wf-school-teacher-filter>
        </div>
      }
      <div class="print-hide filter-options">
        <wf-students-filter
          [grades]="grades()"
          [classes]="classes()"
          [filterExtraSupport]="true"
          (filterChangeEvent)="studentsFilter.set($event)">
        </wf-students-filter>
        <div class="zone-filter">
          <label class="bold">Zone</label>
          <select class="form-select" [(ngModel)]="zoneFilter">
            <option value="All">All Zones</option>
            <option value="Zone 1">Zone 1</option>
            <option value="Zone 2">Zone 2</option>
            <option value="Zone 3">Zone 3</option>
            <option value="Zone 4">Zone 4</option>
            <option value="None">No Zone Data</option>
          </select>
        </div>
      </div>
    </div>
    @let reportTypeDisplay = reportType() === 'usage' ? 'Usage and Progress' : 'Engagement';
    <div class="district-report-header margin-bottom-5">
      <div class="district-report-header-group gap-3">
        <span class="report">Group Report: </span>
        <div class="print-hide flex">
          <input type="radio" value="usage" id="usage-group-report" [(ngModel)]="reportType"/>
          <label for="usage-group-report" style="margin-left: 5px;">Usage and Progress</label>
        </div>
        <div class="print-hide flex">
          <input type="radio" value="engagement" id="engagement-group-report" [(ngModel)]="reportType"/>
          <label for="engagement-group-report" style="margin-left: 5px;">Engagement</label>
        </div>
        <div class="print-show" style="text-transform: capitalize;">{{ reportTypeDisplay }}</div>
        <div class="print-hide flex" id="show-teacher-wrapper">
          <input type="checkbox" id="show-teacher-column" [(ngModel)]="showTeacherColumn" />
          <label for="show-teacher-column" style="margin-left: 5px;">Show Teacher Column</label>
        </div>
        @if (this.showCoTeacherFilter()) {
          <div class="print-hide flex" id="show-shared-wrapper">
            <input type="checkbox" id="hide-shared-students" [(ngModel)]="hideSharedStudents"/>
            <label for="hide-shared-students" style="margin-left: 5px;">Hide Shared Students</label>
          </div>
        }
      </div>
      <div class="flex align-items-end gap-2 report-header-buttons">
        <refresh-button (click)="refresh$.next()"></refresh-button>
        <button id="export-button" class="btn export-report-button print-hide" (click)="exportGroupSummary()" [disabled]="reportExporting()">
          @if (!reportExporting()) {
            <fa-icon [icon]="excelIcon"></fa-icon>
          } @else {
            <fa-icon [icon]="loadingIcon" [spin]="true"></fa-icon>
          }
          Export Results
        </button>
        @if (!currentUser()?.isTeacherReviewUser()) {
          <button id="print-button" class="btn print-summary-button print-hide" (click)="printSummary()">
            <fa-icon [icon]="printIcon"></fa-icon> Print Results
          </button>
        }
      </div>
    </div>
    <table class="report-table">
      <colgroup>
        <col style="width: 250px"/>
        <col/>
        @if (showTeacherColumn()) {
          <col/>
        }
        <col/>
        <col/>
        <col/>
        <col/>
        <col/>
        @if (reportType() === 'usage') {
          <col/>
          <col/>
        }
      </colgroup>
      <thead>
      <ng-template #sortableTableHeader let-column="column">
        <th class="sortable-report-table-header">
          <button
            (click)="updateSort(column)"
            [attr.aria-sort]="sortColumn().column === column ? (sortColumn().reverse ? 'desending' : 'ascending') : undefined"
          >
            {{ column }}
            <div
              [class]=" { 'arrow-up' : !sortColumn().reverse, 'arrow-down': sortColumn().reverse }"
              [style.visibility]="(sortColumn().column !== column) ? 'hidden' : 'visible'"
              class="print-hide"
            ></div>
          </button>
        </th>
      </ng-template>
      <tr>
        <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: COMMON_COLUMNS.STUDENT_NAME }"/>
        <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: COMMON_COLUMNS.GRADE }"/>
        @if (showTeacherColumn()) {
          <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: COMMON_COLUMNS.TEACHER_NAME }"/>
        }
        @if (reportType() === 'usage') {
          <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: USAGE_COLUMNS.DATE_STARTED }"/>
          <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: USAGE_COLUMNS.LAST_USAGE_DATE }"/>
          <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: USAGE_COLUMNS.CURRENT_PLACEMENT }"/>
          <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: USAGE_COLUMNS.PROGRESS }"/>
          <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: USAGE_COLUMNS.CURRENT_ZONE }"/>
          <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: USAGE_COLUMNS.AVERAGE_WEEKLY_USAGE }"/>
          <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: USAGE_COLUMNS.PREVIOUS_WEEK_USAGE }"/>
          <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: USAGE_COLUMNS.CURRENT_WEEK_USAGE }"/>
        } @else {
          <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: ENGAGEMENT_COLUMNS.CURRENT_TEAM }"/>
          <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: ENGAGEMENT_COLUMNS.TOTAL_POINTS }"/>
          <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: ENGAGEMENT_COLUMNS.PREVIOUS_WEEK_POINTS }"/>
          <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: ENGAGEMENT_COLUMNS.CURRENT_LEVEL }"/>
          <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: ENGAGEMENT_COLUMNS.CURRENT_WEEK_LEVELS_COMPLETED }"/>
          <ng-container [ngTemplateOutlet]="sortableTableHeader" [ngTemplateOutletContext]="{ column: ENGAGEMENT_COLUMNS.PREVIOUS_WEEK_LEVELS_COMPLETED }"/>
        }
      </tr>
      </thead>
      <tbody>
        @for (student of studentProgressesFilteredSorted(); track student.studentID) {
          <tr>
            <th scope="row"> {{ student.firstName }} {{ student.lastName }} </th>
            <td> {{ student.grade | displayGrade }} </td>
            @if (showTeacherColumn()) {
              <td> {{ student.teacherFirstName }} {{ student.teacherLastName }} </td>
            }
            @if (reportType() === 'usage') {
              <td> {{ student.startDateTime ? (student.startDateTime | date : DATE_FORMAT) : '—' }} </td>
              <td> {{ student.lastUsageDateTime ? (student.lastUsageDateTime | date : DATE_FORMAT) : '—' }} </td>
              <td> {{ student.activeAssessmentType | studentPlacement : student.highestCompletedAssessmentType : student.levelsCompleted }} </td>
              <td> {{ (student.levelsCompleted === 0) ? '—' : (((student.levelsCompleted / 120 * 100) | number : '1.0-0') + '%') }} </td>
              <td> {{ (student.grade | zone : student.latestSystemScore)?.label ?? '—' }} </td>
              <td> {{ (student.averageWeeklySessionSeconds / 60) | number : '1.0-0' }} </td>
              <td>
                @let previousWeekUsage = (student.previousWeekSessionSeconds / 60) | number : '1.0-0';
                <wf-color-category [level]="(previousWeekUsage ?? 0) | previousWeekUsageCategory">
                  {{ previousWeekUsage | number }}
                </wf-color-category>
              </td>
              <td> {{ (student.currentWeekSessionSeconds / 60) | number : '1.0-0' }} </td>
            } @else {
              <td> {{ student.currentTeamName ?? '' }} </td>
              <td> {{ student.totalPoints | number : '1.0-0' }} </td>
              <td> {{ student.previousWeekPoints | number : '1.0-0' }} </td>
              <td> {{ student.levelsCompleted }} </td>
              <td> {{ student.weeklyLevelsCompleted }} </td>
              <td>
                <wf-color-category [level]="student.previousWeeklyLevelsCompleted | previousWeekLevelCategory">
                  {{ student.previousWeeklyLevelsCompleted }}
                </wf-color-category>
              </td>
            }
          <tr>
        } @empty {
          @if (showSchoolTeacherFilter() && !schoolTeacherFilter()?.school?.schoolID) {
            <tr>
              <td [attr.colspan]="3 + (showTeacherColumn() ? 1 : 0) + (reportType() === 'usage' ? 8 : 6)">
                Please select a school
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </wf-main-content>
</div>
